<script setup lang="ts">
import { nextTick, ref } from 'vue';
import DxTabPanel, { DxItem as DxTabItem } from 'devextreme-vue/tab-panel';
import { BottoPagePanel } from '@botto/core';
import SmppClientsTab from './SmppClientsTab.vue';
import ManagersTab from './ManagersTab.vue';
import PartnersTab from './PartnersTab.vue';

const smppTab = ref<InstanceType<typeof SmppClientsTab> | null>(null);
const managersTab = ref<InstanceType<typeof ManagersTab> | null>(null);
const partnersTab = ref<InstanceType<typeof PartnersTab> | null>(null);

async function onTabSelectionChanged(e: { component?: { option: (name: string) => number } }) {
  await nextTick();
  const index = e.component?.option('selectedIndex') ?? 0;
  const tabs = [smppTab, managersTab, partnersTab];
  tabs[index]?.value?.updateGridDimensions?.();
}
</script>

<template>
  <BottoPagePanel title="Учетные записи" standalone>
    <DxTabPanel
      class="accounts-tabs"
      :animation-enabled="true"
      :swipe-enabled="false"
      :defer-rendering="false"
      @selection-changed="onTabSelectionChanged"
    >
      <DxTabItem title="SMPP (клиенты)">
        <SmppClientsTab ref="smppTab" />
      </DxTabItem>
      <DxTabItem title="Менеджеры">
        <ManagersTab ref="managersTab" />
      </DxTabItem>
      <DxTabItem title="Партнеры">
        <PartnersTab ref="partnersTab" />
      </DxTabItem>
    </DxTabPanel>
  </BottoPagePanel>
</template>

<style scoped>
.accounts-tabs {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.accounts-tabs :deep(.dx-tabpanel-container),
.accounts-tabs :deep(.dx-multiview-wrapper),
.accounts-tabs :deep(.dx-multiview-item) {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.accounts-tabs :deep(.dx-multiview-item-content) {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  padding: 0;
}

.accounts-tabs :deep(.entity-list-page) {
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}
</style>
